<template>
  <div class="p-3">
    <div class="my-results d-inline-block">
      <h1>{{ texts.result }} </h1>
      <p class="mb-2 mb-md-5">
       {{ data ? data.skin_type.userTellingText : '' }}
      </p>
      <p class="mb-3 recommendation-text">
        {{ texts.discountDescriptionText }}
      </p>
      <div class="d-flex flex-column mb-3">
        <div class="discount-code">
          <div class="wrapper m-auto">
            <div class="float-left discount-code-col">
              <span class="btn with-code btn-secondary full b-4">
                {{discountCode}}
              </span>
            </div>
            <div class="float-left discount-code-col">
              <span
                :class="`
                  btn btn-primary btn-buy mr-3 mb-0 mb-md-3
                  ${discountCodeCopied || discountCodestatus ? 'copied' : ''}
                  `
                "
                v-clipboard:copy="discountCode"
                v-clipboard:success="clipboardSuccess"
              >
                {{
                  discountCodeCopied
                  ? texts.copied
                  : (discountCodestatus ? texts.consumed : texts.copy)
                }}
              </span>
            </div>
          </div>
        </div>
        <span class="discount-code-text text-left mb-5">
          {{ texts.discountDisclaimer }}
        </span>
        <a
          class="btn btn-secondary btn-sm"
          :href="data.form.form.test_url"
          target="_top"
        >
          {{ texts.redoTest }}
        </a>
      </div>
      <hr class="separator mb-4" />
      <div v-if="products.length" class="mb-4">
        <h1>{{ data ? ( data.skin_type ? data.skin_type.value : '') : '' }}</h1>
        {{  data ? ( data.skin_type ? data.skin_type.description : '') : '' }}
      </div>
      <hr v-if="products.length" class="separator mb-3" />
      <div class="mb-4">
        <h1 class="mb-4" v-if="products.length">{{ texts.yourSkincareRoutine }} </h1>
        <div v-if="products.length" class="products">
          <div v-for="item in products" :key="item.title">
            <div v-if="item.products.length" >
            <h2>{{item.title }}</h2>
            <div class="product mb-4" v-for="product in item.products" v-bind:key="product.name">
              <div class="d-flex flex-wrap mb-4">
                <div class="product-image p-2 d-flex align-items-center">
                  <div>
                    <img :src="product.thumbnail" />
                  </div>
                </div>
                <div class="d-flex flex-column flex-grow ml-sm-4 product-info">
                  <span class="product-category font-weight-bold">
                    {{ product.brand }}
                  </span>
                  <span class="product-title mb-2 font-weight-medium">{{ product.name }}</span>
                  <span
                    :class="`
                      mt-1 product-price font-weight-bold mb-0
                      ${Number(product.sale_price) && 'on-sale' }
                      ${!Number(product.rek_price) && 'mb-md-4' }
                    `
                  ">
                    <span v-if="Number(product.sale_price)" class="sale-price mr-1">
                      {{ product.sale_price }} {{ texts.currency }}
                    </span>
                    <span>{{ product.price }} {{ texts.currency }}</span>
                  </span>
                  <span v-if="Number(product.rek_price)" class="rek-price mb-0 mb-md-4">
                    {{ texts.recPrice }} {{ product.rek_price }}
                  </span>
                  <span
                    v-if="product.is_out_of_stock"
                    class="w-100 out-of-stock mb-2"
                  >
                    {{ texts.noMoreProducts }}
                  </span>
                  <div class="d-flex mt-2 mt-sm-0">
                    <button
                      v-if="!product.is_out_of_stock"
                      class="btn btn-secondary btn-sm mr-3 full"
                      @click="addToCart(product.sku)"
                    >{{ texts.buy }}</button>
                    <a
                      :href="product.url"
                      target="_top"
                      class="btn btn-secondary btn-sm full"
                    >{{ texts.readMore }}</a>
                  </div>
                </div>
              </div>
              <p class="product-description mb-4">{{ product.description }}</p>
              <hr class="separator mb-3" />
            </div>
          </div>
          </div>
        </div>
        <p class="mb-3 recommendation-text d-block">
          {{ texts.discountDescriptionText }}
        </p>
        <div class="d-flex flex-column mb-3">
          <div class="discount-code">
            <div class="wrapper m-auto">
              <div class="float-left discount-code-col">
                <span class="btn with-code btn-secondary full b-4">
                  {{discountCode}}
                </span>
              </div>
              <div class="float-left discount-code-col">
                <span
                  :class="`
                    btn btn-primary btn-buy mr-3 mb-0 mb-md-3
                    ${discountCodeCopied ||discountCodestatus ? 'copied' : ''}
                  `
                  "
                  v-clipboard:copy="discountCode"
                  v-clipboard:success="clipboardSuccess"
                >
                  {{
                    discountCodeCopied
                    ? texts.copied
                    : (discountCodestatus ? texts.consumed : texts.copy)
                  }}
                </span>
              </div>
            </div>
          </div>
          <span class="discount-code-text text-left mb-5">
            {{ texts.discountDisclaimer }}
          </span>
        </div>
      </div>
    </div>
    <a
      class="d-none"
      id="UserForRedirect"
      href="#addtocart"
      target="_top"
    >
      This a href is used as a workaround to be able to redirect
      user to checkout as window.location.top dont work with different origins
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      products: [],
      data: null,
      price: 0,
      totalProducts: 0,
      sendingCartAddRequest: false,
      webiste_base: this.WEBSITE_BASE,
      discountCode: 'Loading',
      discountCodestatus: false,
      discountCodeCopied: false,
      texts: {},
    };
  },
  methods: {
    returnCorrectLangDomain() {
      const { lang } = this.$route.query;
      if (lang.toLowerCase() === 'no') return 'https://www.bangerhead.no';
      if (lang.toLowerCase() === 'fi') return 'https://www.bangerhead.fi';
      if (lang.toLowerCase() === 'dk') return 'https://www.bangerhead.dk';
      return 'https://www.bangerhead.se/';
    },
    async addToCart(item) {
      this.sendingCartAddRequest = true;
      let products = [item];
      if (item === 'all') {
        products = [];
        await this.products.forEach(async (el) => {
          await el.products.forEach((product) => {
            products.push(product.sku);
          });
        });
      }

      const { id } = this.data.form.form;

      this.$http
        .post(
          'api/cart/add/',
          {
            products,
            id,
          },
          {
            headers: {
              Authorization: this.token,
            },
          },
        )
        .then(response => response.data)
        .then(() => {
          window.parent.postMessage('addToCart', this.returnCorrectLangDomain());
        });
    },
    clipboardSuccess() {
      this.discountCodeCopied = true;
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  async mounted() {
    const { lang } = this.$route.query;
    const { token } = await this;
    await this.$http
      .get(`/api/result/data/${this.$route.params.id}/?lang=${lang || 'sv'}`, {
        headers: {
          Authorization: token,
        },
      })
      .then(response => response.data)
      .then((response) => {
        this.products = response.products;
        this.data = response;

        let price = 0;
        let totalProducts = 0;
        this.products.forEach((el) => {
          el.products.forEach((product) => {
            price += product.price;
            totalProducts += 1;
          });
        });
        this.totalProducts = totalProducts;
        this.texts = response.texts;
        this.price = price;
      });

    this.$http
      .post(
        '/api/cart/code/',
        { id: this.$route.params.id },
        {
          headers: {
            Authorization: token,
          },
        },
      )
      .then(response => response.data)
      .then(async ({ code, status }) => {
        this.discountCode = code;
        this.discountCodestatus = status === 'used';
      });
  },
};
</script>
